import { Box, Button, MenuItem, TextField, Tooltip } from "@mui/material";
import FilterAltSharpIcon from "@mui/icons-material/FilterAltSharp";
import CleaningServicesRoundedIcon from "@mui/icons-material/CleaningServicesRounded";

const SubAbaCorretorFiltro = ({
  nomeFilter,
  setNomeFilter,
  telefoneFilter,
  setTelefoneFilter,
  imobiliariaFilter,
  setImobiliariaFilter,
  regiaoFilter,
  setRegiaoFilter,
  imobiliariasDisponiveis = [],
  regioesDisponiveis = [],
  handleApplyFilters,
  handleClearFilters,
  onOpenCadastro = () => {},
  showCadastro = false,
  cadastroLabel = "Cadastrar novo Corretor",
}) => {
  const uniqueImobiliarias = Array.from(
    new Map(
      imobiliariasDisponiveis.map((imob) => [
        imob.id ?? imob.value ?? imob,
        imob,
      ])
    ).values()
  );

  const uniqueRegioes = Array.from(
    new Map(regioesDisponiveis.map((reg) => [reg.id ?? reg.value ?? reg, reg])).values()
  );

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        borderRadius: { xs: 2, md: 3 },
        p: { xs: 2, md: 3 },
        mb: 2,
        boxShadow: {
          xs: "0 2px 10px rgba(0,0,0,0.08)",
          md: "0 4px 20px rgba(0,0,0,0.08)",
        },
        maxWidth: "100%",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          mb: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <TextField
          label="Nome"
          value={nomeFilter}
          onChange={(e) => setNomeFilter(e.target.value)}
          variant="outlined"
          size="small"
          placeholder="Digite o nome"
          InputLabelProps={{
            shrink: Boolean(nomeFilter),
          }}
          sx={{
            width: 160,
            bgcolor: "background.paper",
            '& .MuiInputBase-input': {
              color: 'text.primary',
            },
            '& .MuiInputLabel-root': {
              color: 'text.secondary',
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: 1.5,
              color: "text.primary",
              "& fieldset": {
                borderColor: "divider",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#667eea",
              },
            },
          }}
        />

        <TextField
          label="Tel/Cel"
          value={telefoneFilter}
          onChange={(e) => setTelefoneFilter(e.target.value.replace(/[^(0-9)+-\s]/g, ""))}
          variant="outlined"
          size="small"
          placeholder="(00) 00000-0000"
          InputLabelProps={{
            shrink: Boolean(telefoneFilter),
          }}
          sx={{
            width: 160,
            bgcolor: "background.paper",
            '& .MuiInputBase-input': {
              color: 'text.primary',
            },
            '& .MuiInputLabel-root': {
              color: 'text.secondary',
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: 1.5,
              color: "text.primary",
              "& fieldset": {
                borderColor: "divider",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#667eea",
              },
            },
          }}
        />

        <TextField
          select
          label="Imobiliária"
          value={imobiliariaFilter}
          onChange={(e) => setImobiliariaFilter(e.target.value)}
          variant="outlined"
          size="small"
          sx={{
            width: 180,
            bgcolor: "background.paper",
            '& .MuiInputLabel-root': {
              color: 'text.secondary',
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: 1.5,
              color: "text.primary",
              "& fieldset": {
                borderColor: "divider",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#667eea",
              },
            },
            '& .MuiSelect-icon': {
              color: 'text.secondary',
            },
          }}
        >
          <MenuItem value="">Todas</MenuItem>
          {uniqueImobiliarias.map((imob, index) => {
            const value = imob.id ?? imob.value ?? imob;
            const label = imob.nome ?? imob.label ?? imob.text ?? String(imob);

            return (
              <MenuItem key={`imob-${value}-${index}`} value={String(value)}>
                {label}
              </MenuItem>
            );
          })}
        </TextField>

        <TextField
          select
          label="Região"
          value={regiaoFilter}
          onChange={(e) => setRegiaoFilter(e.target.value)}
          variant="outlined"
          size="small"
          sx={{
            width: 180,
            bgcolor: "background.paper",
            '& .MuiInputLabel-root': {
              color: 'text.secondary',
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: 1.5,
              color: "text.primary",
              "& fieldset": {
                borderColor: "divider",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#667eea",
              },
            },
            '& .MuiSelect-icon': {
              color: 'text.secondary',
            },
          }}
        >
          <MenuItem value="">Todas</MenuItem>
          {uniqueRegioes.map((regiao, index) => {
            const value = regiao.id ?? regiao.value ?? regiao;
            const label = regiao.nome ?? regiao.label ?? regiao.text ?? String(regiao);

            return (
              <MenuItem key={`regiao-${value}-${index}`} value={String(value)}>
                {label}
              </MenuItem>
            );
          })}
        </TextField>

        <Tooltip title="Aplicar filtros" arrow>
          <Button
            variant="contained"
            onClick={handleApplyFilters}
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              minWidth: "auto",
              width: 38,
              height: 38,
              borderRadius: "50%",
              padding: 0,
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              "&:hover": {
                background: "linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)",
                boxShadow: "0 6px 20px rgba(102, 126, 234, 0.3)",
                transform: "translateY(-1px)",
              },
            }}
          >
            <FilterAltSharpIcon />
          </Button>
        </Tooltip>

        <Tooltip title="Limpar filtros" arrow>
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{
              borderColor: "primary.main",
              color: "primary.main",
              bgcolor: (theme) =>
                theme.palette.mode === "dark"
                  ? "rgba(42, 133, 226, 0.12)"
                  : "transparent",
              minWidth: "auto",
              width: 38,
              height: 38,
              borderRadius: "50%",
              padding: 0,
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              "&:hover": {
                borderColor: "primary.light",
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark"
                    ? "rgba(42, 133, 226, 0.22)"
                    : "rgba(102, 126, 234, 0.08)",
                boxShadow: "0 6px 20px rgba(102, 126, 234, 0.2)",
                transform: "translateY(-1px)",
              },
            }}
          >
            <CleaningServicesRoundedIcon />
          </Button>
        </Tooltip>

        {showCadastro && (
          <Button
            variant="contained"
            onClick={onOpenCadastro}
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              height: 38,
              borderRadius: 2,
              px: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": {
                background: "linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)",
                boxShadow: "0 6px 20px rgba(102, 126, 234, 0.3)",
                transform: "translateY(-1px)",
              },
            }}
          >
            {cadastroLabel}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default SubAbaCorretorFiltro;
